import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'

interface DataModel {
	aid?: string
	cid?: string
}

/**
 *	查询直播功能总览数据
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.aid] aid
 * @param {string} [data.cid] cid
 */

export function funcliveoverview(data: DataModel, options: IRequestOptionsWithPass): Promise<any>
export function funcliveoverview(
	data: DataModel,
	options?: IRequestOptions,
): Promise<any extends { msg: unknown } ? any['msg'] : undefined>
export function funcliveoverview(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { aid, cid } = data
	return net('/frontApi/app/func/live/overview', {
		method: 'post',
		params: {
			aid,
			cid,
		},

		...(options || {}),
	})
}
